import { User } from 'lucide-react';

interface UserBubbleProps {
  content: string;
  time?: string;
}

export const UserBubble = ({ content, time }: UserBubbleProps): JSX.Element => (
  <div className="flex w-full justify-end gap-2.5">
    <div className="flex max-w-[75%] flex-col items-end gap-1">
      <div className="rounded-2xl rounded-tr-md bg-[#0000FF] px-4 py-2.5 text-white">
        <p className="whitespace-pre-wrap break-words text-sm leading-relaxed">{content}</p>
      </div>
      {time && <p className="px-1 text-[11px] text-neutral-400">{time}</p>}
    </div>
    <span className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#0000FF]/10">
      <User className="h-4 w-4 text-[#0000FF]" />
    </span>
  </div>
);
